<!-- =========================================================================================
    File Name: StatisticsCard.vue
    Description: Statistics card component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <vx-card class="overflow-hidden">
      <!-- {{module_name}} -->
        <div slot="no-body">
            <div class="p-6" :class="{
              'flex flex-wrap justify-between flex-row-reverse': iconRight,
              'text-center': !iconRight && hideChart,
              'pb-0': !hideChart
            }">
            <vs-tooltip :text="textDecorator(module_name)" color="primary">
              <span class="material-icons-outlined p-3 inline-flex rounded-full" :class="[`text-${color}`, {'mb-4': !iconRight}]" :style="{background: `rgba(var(--vs-${color}),.15)`}">{{ icon }}</span>
              <!-- <span class="material-icons-outlined p-3 inline-flex rounded-full" :class="[`module-${module_name.toLowerCase()}`, {'mb-4': !iconRight}]">{{ icon }}</span> -->
            </vs-tooltip>
                <!-- <feather-icon :icon="icon" class="p-3 inline-flex rounded-full" :class="[`text-${color}`, {'mb-4': !iconRight}]" :style="{background: `rgba(var(--vs-${color}),.15)`}"></feather-icon> -->
                <div class="stat_info_holder">
                    <h2 class="mb-1 font-bold">{{ statistic }}

                      <!-- Information coming from education/ gradebook module -->
                      <span v-if="module_name === 'grade_homework_total_points' || module_name === 'Homework Total Points'"> / {{homework_total_points}}</span>
                      <span v-if="module_name === 'grade_exam_total_points' || module_name === 'Exam Total Points'"> / {{exam_total_points}}</span>
                      <span v-if="module_name === 'grade_homework_exam_total_points'">/ {{homework_exam_total_points}}</span>
                    </h2>

                    <span 
                      class="cstm_dashboard_stat_card" 
                      v-if="$route.name === 'dashboard-analytics'" 
                      :title="statisticTitle"
                    >
                      {{ statisticTitle }}
                    </span>
                    <span v-else>{{ statisticTitle }}</span>
                </div>
            </div>

            <div class="line-area-chart" v-if="!hideChart">
                <vue-apex-charts ref="apexChart" :type="type" height="100" width="100%" :options="chartOptions" :series="chartData" />
            </div>
        </div>
    </vx-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import chartConfigs from './chartConfigs.js'
import _color from '@/assets/utils/color.js'

export default{
  props: {
    module_name: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    homework_total_points:{
      type: [Number, String]
    },
    exam_total_points:{
      type: [Number, String]
    },
    homework_exam_total_points:{
      type: [Number, String]
    },
    statistic: {
      type: [Number, String],
      required: true
    },
    statisticTitle: {
      type: String
    },
    chartData: {
      // type: Array,
      // required: true
    },
    color: {
      type: String,
      default: 'primary'
    },
    colorTo: {
      type: String
    },
    // chartType: {
    //     type: String,
    //     default: 'line-chart',
    // },
    type: {
      type: String,
      default: 'line'
    },
    iconRight: {
      type: Boolean,
      default: false
    },
    hideChart: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      chartOptions: null
    }
  },
  watch: {
    themePrimaryColor () {
      this.$refs.apexChart.updateOptions({ theme: { monochrome: { color: this.getHex(this.color) } } })
    }
  },
  computed: {
    themePrimaryColor () {
      return this.$store.state.themePrimaryColor
    }
  },
  methods: {
    textDecorator (text) {
      const decoratedTextArray = text.split('_')
      const decoratedText = decoratedTextArray.join(' ')
      return decoratedText.toUpperCase()
    },
    getHex (color) {
      if (_color.isColor(color)) {
        let rgb  = window.getComputedStyle(document.documentElement).getPropertyValue(`--vs-${color}`)
        rgb = rgb.split(',')
        return `#${  ((1 << 24) + (Number(rgb[0]) << 16) + (Number(rgb[1]) << 8) + Number(rgb[2])).toString(16).slice(1)}`
      }
      return color
    },
    gradientToColor (color) {
      const gradientToColors = {
        'primary': '#A9A2F6',
        'success': '#55DD92',
        'warning': '#ffc085',
        'danger': '#F97794'
      }

      return gradientToColors[color] ? gradientToColors[color] : gradientToColors['primary']
    }
  },
  components: {
    VueApexCharts
  },
  created () {
    if (this.type === 'area') {
      // assign chart options
      this.chartOptions = Object.assign({}, chartConfigs.areaChartOptions)

      this.chartOptions['theme'] = {
        monochrome: {
          enabled: true,
          color: this.getHex(this.color),
          shadeTo: 'light',
          shadeIntensity: 0.65
        }
      }
    } else if (this.type === 'line') {
      // Assign chart options
      this.chartOptions = JSON.parse(JSON.stringify(chartConfigs.lineChartOptions))

      this.chartOptions.fill.gradient.gradientToColors = [this.gradientToColor(this.colorTo || this.color)]
      this.chartOptions.colors = [this.getHex(this.color)]
    }
  }
}
</script>
<style>
/* .module-crm {
  color: rgb(65, 207, 221);
  background-color: rgba(65, 207, 221, 0.15);
}
.module-courses {
  color: rgb(255, 153, 0);
  background-color: rgba(255, 153, 0, 0.15);
}
.module-students {
  color: rgb(0, 38, 255);
  background-color: rgba(0, 38, 255, 0.15);
}
.module-finance {
  color: rgb(170, 0, 255);
  background-color: rgba(170, 0, 255, 0.15);
}
.module-tasks {
  color: rgb(0, 199, 0);
  background-color: rgba(0, 199, 0, 0.15);
}
.module-rooms {
  color: rgb(0, 33, 196);
  background-color: rgba(0, 33, 196, 0.15);
}
.module-staff {
  color: rgb(164, 176, 0);
  background-color: rgba(164, 176, 0, 0.15);
}
.module-inventory {
  color: rgb(0, 168, 252);
  background-color: rgba(0, 168, 252, 0.15);
}
.module-project {
  color: rgb(99, 255, 99);
  background-color: rgba(99, 255, 99, 0.15);
} */
</style>